import type { Header } from '@tanstack/react-table'
import { ArrowDownIcon, ArrowUpIcon, ChevronsUpDownIcon } from 'lucide-react'

import { cn } from '@/utils'
import type { TableData } from './types'

interface DataTableHeaderSortProps {
  header: Header<TableData, unknown>
}

export const DataTableHeaderSort = function DataTable({
  header,
}: DataTableHeaderSortProps) {
  const isSorted = header.column.getIsSorted()
  const canSort = header.column.getCanSort()

  if (!canSort) return

  let Icon = ChevronsUpDownIcon
  if (isSorted === 'asc') Icon = ArrowUpIcon
  if (isSorted === 'desc') Icon = ArrowDownIcon

  return (
    <span className="w-4 h-4 flex items-center justify-center text-muted-foreground">
      <Icon className={cn('h-3.5 w-3.5', !isSorted && 'opacity-50')} />
    </span>
  )
}
